const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/InvoicePage/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        chooseReport: 'Rechnung auswählen',
        noInvoices: 'Keine Rechnungen',
        cardTitle: 'Rechnungskopien',
    },
    __RELATIVE_SOURCE_FILE__
);
